module.exports = __webpack_public_path__ + "img/17.ad95848f.png";